import Vue from 'vue'

class Bus {
  constructor() {
    this.bus = new Vue()
  }
  EMIT_E_PASS_INDEX_4_DEL_ITEM(index) {
    this.bus.$emit('deleteItemByIndex', index)
  }
  ON_E_DEL_ITEM_BY_PASSED_INDEX(cb) {
    this.bus.$on('deleteItemByIndex', cb)
  }
}
export default new Bus()
